
export default {
    props: ['campusText', 'campusLogoHeader',
        'collone1Diplomas', 'collone2Diplomas', 'collone3Diplomas',
        'nomCollone1', 'nomCollone2', 'nomCollone3', 'global',
        'campusLogoHeaderDetailCampusValidation'],
    data() {
        return {
            ref: null,
            showListDiploma: false,
            openNavBar: false,
        };
    },
    methods: {
        openDiplomasList(event) {
            this.showListDiploma = !this.showListDiploma;
        },
        close(e) {
            if (!this.$el.contains(e.target)) {
                this.showListDiploma = false
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.close)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.close)
    }
}
